import React, { useRef, useState } from 'react';
import { Button, Spin } from 'antd';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { normalizeToSelect, useCrud } from '@unicus/react-ui-kit';
import RemoteSelect from './RemoteSelect';
import RemoteSelectV2 from './RemoteSelectV2';

const RemoteSelectAutoCrud = ({
  resource,
  textPropName,
  resourceTitle,
  enableEdit = true,
  onChange,
  value,
  onCreate,
  onBeforeCreate,
  useVersionV2,
  ...rest
}) => {
  const ref = useRef(null);
  const { get, post } = useCrud({ resource });
  const [text, setText] = useState('');
  const [allowShow, setAllowShow] = useState(true);
  const isMultiple = rest.mode === 'multiple';

  const handleChange = (item) => {
    onChange?.(item);
  };

  const handleCreateSucess = ({ data: result }) => {
    ref.current.add(result.result);

    if (isMultiple) {
      const newValue = [...value];
      newValue.push({
        ...normalizeToSelect(result.result),
        item: result.result
      });

      handleChange(newValue);
    } else {
      handleChange({
        ...normalizeToSelect(result.result),
        item: result.result
      });
    }

    onCreate?.(result.result);

    return false;
  };

  const handleCreate = () => {
    ref.current.reset();
    setText('');

    const values = onBeforeCreate(text);
    post(values, (response) => handleCreateSucess(response));
  };

  const handleEditClickTag = (key) => {
    get(key);
  };

  const notFoundRender = () => {
    return allowShow && text ? (
      <Button
        className="gx-remote-select-crud-add-button"
        onClick={handleCreate}
      >
        + Adicionar{text ? ` (${text}...)` : ''}
      </Button>
    ) : null;
  };

  const customDropdownRender = ({ menu, fetching }) => {
    return (
      <>
        {menu}
        {fetching ? (
          <div className="gx-remote-select-spin">
            <Spin size="default" />
          </div>
        ) : (
          notFoundRender()
        )}
      </>
    );
  };

  const handleSearch = (text) => {
    setAllowShow(false);
    setText(text);
  };

  const handleFetched = () => {
    setAllowShow(true);
  };

  const handleDropdownVisibleChange = (visible) => {
    if (!visible) {
      setText('');
    }
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13 && ref.current.isEmpty() && text) {
      handleCreate();
    }
  };

  const tagRender = ({ label, onClose, value }) => {
    return (
      <div className="ant-select-selection-item">
        <span className="gx-mr-2">{label}</span>
        <div>
          <EditOutlined
            className="gx-mr-1"
            onClick={() => handleEditClickTag(value)}
          />
          <CloseOutlined onClick={onClose} />
        </div>
      </div>
    );
  };

  if (useVersionV2) {
    <div role="button" tabIndex="0" onKeyDown={onKeyDown}>
      <RemoteSelectV2
        resource={resource}
        searchValue={text}
        onSearch={handleSearch}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        customDropdownRender={customDropdownRender}
        onFetched={handleFetched}
        tagRender={isMultiple ? tagRender : undefined}
        notFoundContent={() => <div />}
        ref={ref}
        value={value}
        onChange={handleChange}
        {...rest}
      />
    </div>;
  }

  return (
    <div role="button" tabIndex="0" onKeyDown={onKeyDown}>
      <RemoteSelect
        resource={resource}
        searchValue={text}
        onSearch={handleSearch}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        customDropdownRender={customDropdownRender}
        onFetched={handleFetched}
        tagRender={isMultiple ? tagRender : undefined}
        notFoundContent={() => <div />}
        ref={ref}
        value={value}
        onChange={handleChange}
        {...rest}
      />
    </div>
  );
};

export default RemoteSelectAutoCrud;
